export default __webpack_public_path__ + "static/media/Stargiga.bb4a2d9a.png";